import React from "react";
import ApiConfig from "../../config/ApiConfig";
import AvatarPopover from "../../commonComponent/AvtarPopover";
import { useHover } from "../../customHook/useHover";

function ViewMemberListSession({ member }) {
  const { hoveredUserId, handleMouseEnter, handleMouseLeave } = useHover();

  return (
    <div
      className="d-flex align-items-center  border-bottom py-2"
      // style={{borderBottom:'2px solid rgba(164, 164, 164, 0.5)'}}
      key={member?.user_id}
    >
      <div
        className="avatar_warper me-2"
        onMouseEnter={() => handleMouseEnter(member._id)}
        onMouseLeave={handleMouseLeave}
      >
        <img
          src={
            member.userprofilePicture
              ? member.userprofilePicture
              : "images/avatar.png"
          }
          onError={(e) => (e.target.src = "images/avatar.png")}
          alt="not rendered"
          className=" object-fit-cover me-2"
          style={{
            height: "40px",
            width: "40px",
            borderRadius: "50%",
          }}
        />
        <AvatarPopover data={member} onHover={member._id === hoveredUserId} />
      </div>
      <div className="flex flex-column justify-content-center ">
        <h3 style={{ fontSize: "16px" }}>{member.userName}</h3>
      </div>
    </div>
  );
}

export default ViewMemberListSession;
